// material-ui
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

// project-imports
import LoginForm from './components/LoginForm';
import LoginHeroPanel from './components/LoginHeroPanel';

export default function Login() {
  return (
    <Grid container sx={{ minHeight: '100vh', bgcolor: '#faf7f5' }}>
      <Grid size={{ xs: 12, md: 6 }} sx={{ display: { xs: 'none', md: 'block' } }}>
        <LoginHeroPanel />
      </Grid>

      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#fffdfb',
          px: { xs: 2.5, sm: 5, lg: 7 },
          py: { xs: 5, md: 7 }
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 820 }}>
          <LoginForm />
        </Box>
      </Grid>
    </Grid>
  );
}
